<template>
  <div class="components-container">
    <el-dialog :visible.sync="isShowModel" width="65%" center>
      <el-form
        :model="fileItem"
        ref="fileItem"
        label-width="0px"
        class="demo-dynamic form-horizontal detailPage"
      >
        <div class="form-group" style="display: flex; align-items: center">
          <label class="col-sm-3 control-label"> Picture / Video </label>
          <div class="col-sm-5">
            <el-form-item
              prop="fileType"
              :rules="{
                required: false,
                message: $t('message.required'),
                trigger: 'change',
              }"
            >
              <el-select
                v-model="fileItem.fileType"
                v-bind:placeholder="$t('message.PleaseSelect')"
                @change="handleSelectFileType"
              >
                <el-option
                  v-for="item in [
                    { value: 1, label: 'Picture' },
                    { value: 3, label: 'Video' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled ="item.value==3 && !allowAddVideo"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="form-group" v-if="fileItem.fileType == 3">
          <label class="col-sm-3 control-label"> Video URL </label>
          <div class="col-sm-9">
            <el-form-item
              prop="fileUrl"
              :rules="{
                required: false,
                message: $t('message.required'),
                trigger: 'blur',
              }"
            >
              <el-input
                v-model="fileItem.fileUrl"
                show-word-limit
                style="margin-bottom: 22px"
                @change="i=>fileItem.showFileUrl = fileItem.fileUrl"
              ></el-input>
            </el-form-item>
            <video
              :src="fileItem.fileUrl"
              class="avatar"
              controls="controls"
              style="width: 100%; max-width: 610px"
            ></video>
          </div>
        </div>
        <div class="form-group" v-if="fileItem.fileType == 3">
          <label class="col-sm-3 control-label">
            Video Thumbnail Image
          </label>
          <div class="col-sm-9">
            <el-upload
              class="upload-demo upload-image"
              style="width: 100%"
              action="#"
              multiple
              :http-request="uploadFile"
              :auto-upload="true"
              accept=".png, .jpg , .jpeg"
              :show-file-list="false"
            >
              <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
              <div class="input-group img-group">
                <div class="text-center dropzone logo">
                  <div
                    class="addImage"
                    v-if="!fileItem.showVideoImgCover"
                    style="width: 100%; padding-top: 25px; color: #fff"
                  >
                    <a class="addImageIcon btn btn-primary btn-circle">
                      <i class="el-icon-upload2"></i>
                    </a>
                    <p class="text-primary m-t-sm font14 suggestFont">
                      <slot name="sizeHint"></slot>
                    </p>
                  </div>
                  <div
                    class="editImage"
                    v-if="fileItem.showVideoImgCover"
                  >
                    <div class="mask-bg"></div>
                    <img :src="fileItem.showVideoImgCover" />
                    <div class="icon-center">
                      <span class="edit-icon">
                        <i class="el-icon-edit"></i>
                      </span>
                      <p class="font14 font-white editFont">Modify</p>
                      <p
                        class="
                          text-primary
                          font-white
                          m-t-sm
                          font14
                          suggestFont
                        "
                      >
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="form-group"  v-if="fileItem.fileType == 1">
          <label class="col-sm-3 control-label">
            Image
          </label>
          <div class="col-sm-9">
            <el-upload
              class="upload-demo upload-image"
              style="width: 100%"
              action="#"
              multiple
              :http-request="uploadFile"
              :auto-upload="true"
              accept=".png, .jpg , .jpeg"
              :show-file-list="false"
            >
              <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
              <div class="input-group img-group">
                <div class="text-center dropzone logo">
                  <div
                    class="addImage"
                    v-if="!fileItem.showFileUrl"
                    style="width: 100%; padding-top: 25px; color: #fff"
                  >
                    <a class="addImageIcon btn btn-primary btn-circle">
                      <i class="el-icon-upload2"></i>
                    </a>
                    <p class="text-primary m-t-sm font14 suggestFont">
                      <slot name="sizeHint"></slot>
                    </p>
                  </div>
                  <div
                    class="editImage"
                    v-if="fileItem.showFileUrl"
                  >
                    <div class="mask-bg"></div>
                    <img :src="fileItem.showFileUrl" />
                    <div class="icon-center">
                      <span class="edit-icon">
                        <i class="el-icon-edit"></i>
                      </span>
                      <p class="font14 font-white editFont">Modify</p>
                      <p
                        class="
                          text-primary
                          font-white
                          m-t-sm
                          font14
                          suggestFont
                        "
                      >
                        <slot name="sizeHint"></slot>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-upload>
            <el-form-item
              prop="fileUrl"
              :rules="{
                required: true,
                message: $t('message.required'),
                trigger: 'blur',
              }"
            >
              <el-input
                style="display: none"
                v-model="fileItem.fileUrl"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModel">Cancel</el-button>
        <el-button type="primary" @click="handleAddFile">Add</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import config from "../../config";
export default {
  name: "upload-video-or-picture",
  components: {},
  mixins: [config.globalMixin],
  data() {
    return {
      fileItem: {
        videoImgCover: null,
        fileUrl: "",
        fileType: 1,
        showVideoImgCover: null,
        showFileUrl: "",
        sortOrder: 0,
        type: 0,
      },
      videoCache:{},
      pictureCache:{},
      isShowModel: false,
      uploadErr:false
    };
  },
  props: {
    isShowAddModel: {
      type: Boolean,
      default: false,
    },
    allowAddVideo: {
      type: Boolean,
      default: true,
    },
    newSortOrder: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    isShowModel: {
      handler: function (e) {
        if (!e) this.$emit("close", e);
      },
    },
    isShowAddModel: {
      handler: function (e) {
        if (e) {
          this.isShowModel = e;
        }
      },
      immediate: true,
    },
  },
  computed: {},
  methods: {
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false 
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.fileItem[
        this.fileItem.fileType == 1 ? "fileUrl" : "videoImgCover"
      ] = data.data.result.url;
      this.fileItem[
        this.fileItem.fileType == 1
          ? "showFileUrl"
          : "showVideoImgCover"
      ] = data.data.result.showUrl;
    },
    closeModel(){
      this.fileItem = {
        videoImgCover: null,
        fileUrl: "",
        fileType: 1,
        showVideoImgCover: null,
        showFileUrl: "",
        sortOrder: 0,
        type: 0,
      },
      this.pictureCache = this.fileItem
      this.videoCache = {fileType: 3,...this.fileItem}
      this.isShowModel = false
    },
    handleAddFile(){
      this.$refs["fileItem"].validate((valid) => {
        if (valid) {
          this.fileItem.sortOrder=this.newSortOrder
          this.$emit("addFile",this.fileItem)
          this.closeModel()
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleSelectFileType(e){
      if(e==3) {
        this.pictureCache = this.fileItem
        this.fileItem = this.videoCache
      }else{
        this.videoCache = this.fileItem
        this.fileItem = this.pictureCache
      }
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    }
  },
  mounted() {},
  created() {
    this.pictureCache = this.fileItem
    this.videoCache = {...this.fileItem,fileType: 3}
  },
};
</script>
<style lang="scss" scoped>
.components-container {
}
</style>
